module.exports = __webpack_public_path__ + "img/Miller-High-Life.4946a762.png";